const PATH = process.env.VUE_APP_BASE_PATH

const state = {
  sidebar: {
    withoutAnimation: true
  },
  device: 'desktop',
  /** 全局Loading */
  showLoading: false,
  eventBus: {}
}

const mutations = {
  TOGGLE_SIDEBAR: (state) => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SHOW_LOADING: (state) => {
    state.showLoading = true
  },
  HIDE_LOADING: (state) => {
    state.showLoading = false
  },
  /**
   * 自定义 event bus {
   *   msg: '',
   *   callback: Function,
   *   target: this指向
   * }
   */
  ADD_EVENT: (state, e) => {
    if (!state.eventBus[e.msg]) {
      state.eventBus[e.msg] = []
    }
    state.eventBus[e.msg].push(e)
  },
  TRIGGER_EVENT: (state, e) => {
    if (state.eventBus[e.msg]) {
      state.eventBus[e.msg].forEach((item) => {
        if (typeof item.callback === 'function') {
          item.callback.call(item.target, e.value)
        }
      })
    }
  },
  OFF_EVENT: (state, e) => {
    if (state.eventBus[e.msg]) {
      const index = state.eventBus[e.msg].findIndex((item) => {
        return item.callback === e.callback
      })
      if (index > -1) {
        state.eventBus[e.msg].splice(index, 1)
      }
    }
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  showLoading({ commit }) {
    commit('SHOW_LOADING')
  },
  hideLoading({ commit }) {
    commit('HIDE_LOADING')
  },
  on({ commit }, e) {
    commit('ADD_EVENT', e)
  },
  emit({ commit }, e) {
    commit('TRIGGER_EVENT', e)
  },
  off({ commit }, e) {
    commit('OFF_EVENT', e)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
